import FalconCloseButton from 'components/common/FalconCloseButton';
import SoftBadge from 'components/common/SoftBadge';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import useToken from '../../hooks/useToken';
import { useForm } from 'react-hook-form';
import { useToast } from 'context/providers/ToastProvider';

const ModalCancelarLicencia = ({
    setShowModalCancelacion,
    showModalCancelacion,
    idLicencia,
    getInformacionDetalladaLicenciaByID,

}) => {
    const [procesandoModal, setProcesandoModal] = useState(false);
    const { register, reset, handleSubmit, formState: { errors } } = useForm();
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    /**
     * Submit de cancelacion
     * @param {any} data
     */
    const onSubmitCancelacion = data => {
        setProcesandoModal(true);
        console.log(data.vMotivo);
        cancelarLicencia(data.vMotivo);
    };


    /**
     * Este metodo cancela la licencia actual
     * @param {any} vMotivo
     */
    const cancelarLicencia = async (vMotivo) => {
        const response = await fetch("/api/licencia/cancelarlicencia/?id=" + idLicencia + "&vMotivo=" + encodeURIComponent(vMotivo), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data["table1"]);
            getInformacionDetalladaLicenciaByID();

            showSuccessToast(data["table1"][0].vMessage);


        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setShowModalCancelacion(false);
        setProcesandoModal(false);
        reset();
    };


    return (
        showModalCancelacion &&
        <Modal
            show={showModalCancelacion}
            onHide={() => setShowModalCancelacion(false)}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Form noValidate onSubmit={handleSubmit(onSubmitCancelacion)}>
                <Modal.Header>
                    <Modal.Title >Cancelar Licencia</Modal.Title>
                    <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalCancelacion(false); reset() }} />
                </Modal.Header>
                <Modal.Body>
                    <h4>&iquest;Est&aacute; seguro que desea cancelar la licencia?</h4>
                    <Row>
                        <Col md={12}>
                            Este proceso har&aacute; que la licencia se cambie a un estado de  <SoftBadge bg='danger' className='me-2'>NO ACTIVO</SoftBadge>.
                            Esto significa que el usuario no podr&aacute; usar la licencia a&uacute;n cuando se encuentre en MODO PRUEBA. Este proceso <SoftBadge bg='danger' className='me-2'>no podr&aacute; ser revertido.</SoftBadge> Si la licencia a cancelar es una licencia tipo Servidor, se cancelar&aacute;n las p&oacute;lizas y licencias Tipo caja Adicional vinculadas.
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <hr></hr>
                            <Form.Group className="mb-3">
                                <Form.Label>Motivo de cancelaci&oacute;n:</Form.Label>
                                <Form.Control
                                    onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                    as="textarea"
                                    name="vMotivo"
                                    autoComplete="off"
                                    placeholder="Escribe el motivo de cancelaci&oacute;n"
                                    isInvalid={!!errors.vMotivo}
                                    {...register('vMotivo', {
                                        required: 'Es necesario escribir el motivo'
                                    })}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.vMotivo && errors.vMotivo.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => { setShowModalCancelacion(false); reset() }} variant='primary' >Cerrar</Button>
                    {procesandoModal ? <Button variant="primary" disabled>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        Procesando...
                    </Button> : <Button type="submit" variant='danger' >Cancelar licencia</Button>}
                </Modal.Footer>
            </Form>
        </Modal>

    )
}

ModalCancelarLicencia.propTypes = {
    idLicencia: PropTypes.string,
    getInformacionDetalladaLicenciaByID: PropTypes.func,
    setShowModalCancelacion: PropTypes.func,
    showModalCancelacion: PropTypes.bool
};

export default ModalCancelarLicencia;